import { api } from '@/shared/redux/api/_generated/api/notifications-api.generated';

export const notificationsApi = api.enhanceEndpoints({
  addTagTypes: ['Notification', 'Webhook', 'Tenant', 'Secret', 'Gateway'],
  endpoints: {
    ReadAllNotifications: {
      providesTags: [{ type: 'Notification', id: 'LIST' }],
    },
    UnreadNotificationsCount: {
      providesTags: [{ type: 'Notification', id: 'UNREAD_COUNT' }],
    },
    ReadAllWebhookConfigurations: {
      providesTags: [{ type: 'Webhook', id: 'LIST' }],
    },
    CreateWebhookConfiguration: {
      invalidatesTags: [{ type: 'Webhook', id: 'LIST' }],
    },
    UpdateWebhookConfiguration: {
      invalidatesTags: [{ type: 'Webhook', id: 'LIST' }],
    },
    DeleteWebhookConfiguration: {
      invalidatesTags: [{ type: 'Webhook', id: 'LIST' }],
    },
    UpdateNotificationReadStatus: {
      invalidatesTags: [
        { type: 'Notification', id: 'LIST' },
        { type: 'Notification', id: 'UNREAD_COUNT' },
      ],
    },
  },
});

export const {
  useReadAllNotificationsQuery,
  useReadAllWebhookConfigurationsQuery,
  useLazyReadAllWebhookConfigurationsQuery,
  useReadWebhookEventsQuery,
  useCreateWebhookConfigurationMutation,
  useUpdateWebhookConfigurationMutation,
  useDeleteWebhookConfigurationMutation,
  useLazyReadAllowedWebhookModelKeysQuery,
  useUpdateNotificationReadStatusMutation,
  useUnreadNotificationsCountQuery,
} = notificationsApi;
